import { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./index.css";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import SVGComponent from "../../SVGComponent";
import { is } from "date-fns/locale";
import ICONS from "../../../../assets/Icons";

/**
 * @callback InputHandler
 * @param {string} data
 * @returns {undefined}
 */
/**
 * @param {Object} props
 * @param {String} props.searchText - input value
 * @param {String} props.searchBgColor - background color  for search field
 * @param {Object} [props.searchRef] - ref for input field
 * @param {String} props.placeholder - placeholder for input field
 * @param {Boolean} [props.isDisabled] - disabled attribute for input field
 * @param {InputHandler} props.onInput - Function to process input.
 * @returns {JSX.Element}
 */
const SearchField = ({
  loading,
  onInput,
  searchText,
  searchRef,
  placeholder,
  isDisabled,
  searchBgColor,
  ctaBtn,
  isTopNav,
  isTopNavSearch,
}) => {
  const [overflowFlags, setOverflowFlags] = useState("");
  const optionRefs = useRef(null);
  const [placeholderText, setPlaceholderText] = useState(`${placeholder}   `);

  const searchAnimate = () => {
    const el = optionRefs.current;
    setOverflowFlags(
      placeholder?.length * GlobalConfiguration.dinLength >
        el?.scrollWidth - GlobalConfiguration.placeHolderAnimationLength,
    );
  };

  useLayoutEffect(() => {
    if (placeholder) {
      searchAnimate();
      setPlaceholderText(`${placeholder}   `);
    }
  }, [placeholder]);

  useEffect(() => {
    if (overflowFlags) {
      const interval = setInterval(() => {
        setPlaceholderText((prev) => prev.slice(1) + prev.charAt(0));
      }, IntervalConfiguration.intervalExtraSmall);

      return () => clearInterval(interval);
    } else {
      setPlaceholderText(`${placeholder}   `);
    }
  }, [overflowFlags]);

  useEffect(() => {
    const handleResize = () => {
      searchAnimate();
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePaste = (event) => {};

  const handlechange = (e) => {
    onInput(e.target.value);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    searchRef?.current?.focus();
    onInput("");
  };
  let isAutoFocus = isTopNav && isTopNavSearch;

  return (
    <div
      className={`searchComponent_bar_accs  mt-[var(--border)] ${isDisabled ? "searchComponent_bar_accs_disabled" : ""} `}
    >
      <div className="searchComponent_inner_image flex justify-center items-center">
        {" "}
        <SVGComponent
          url={ICONS?.SEARCH_WHITE}
          color="var(--text-primary)"
          height="var(--icon-sm)"
          width="var(--icon-sm)"
          alt="search"
        />
      </div>
      <div ref={optionRefs}>
        <input
          onClick={(e) => {
            if (isTopNavSearch) e.stopPropagation();
          }}
          ref={searchRef}
          style={{
            backgroundColor: searchBgColor
              ? searchBgColor
              : "var(--primary-bg)",
          }}
          value={searchText}
          disabled={isDisabled}
          autoFocus={isAutoFocus}
          onInput={handlechange}
          onPaste={handlePaste}
          autoComplete="off"
          id="searchField"
          name="search"
          className={`${isDisabled || loading ? "cursor-not-allowed opacity-light-opacity" : ""} block  rounded-border-radius-md   text-text-primary placeholder:text-text-secondary placeholder:text-font-xs placeholder:ml-margin-lg `}
          placeholder={placeholderText}
          type="text"
        />
      </div>
      {searchText && (
        <img
          onClick={handleClear}
          className={`searchComponent_close_image cursor-pointer ${ctaBtn ? "mr-margin-sm" : "mr-margin-md"}`}
          src={ICONS?.CLOSE}
          alt="search-close"
        />
      )}
    </div>
  );
};

export default SearchField;
